// @flow

import React from 'react';
import styled from 'styled-components';
import Select from 'react-select';
import OptionList from 'models/OptionList';
import { getCustomStyle } from 'styles/SelectIndex';

const StyledValidatedInput = styled.div`
  position: relative;
  margin-bottom: 12px;
`;

const StyledSelect = styled(Select)`
  margin-bottom: 3px;
`;

const ErrorMessage = styled.span.attrs({
  className: 'error-message'
})`
  color: red;
  top: 35px;
  font-size: 14px;
`;

type SelectElement = {
  value: string,
  label: string
};

type PropsType = {
  name: string,
  placeholder?: string,
  minSize: number,
  options: Array<SelectElement> | Array<OptionList>,
  isSearchable: boolean,
  onValueChange: (value: string, input: string) => void,
  value: string,
  schema?: any,
  children?: any,
  customStyles?: any,
  allowComponentUpdate?: boolean,
  enabled?: boolean
};

type StateType = {
  error: string,
  touched: boolean,
  inputValue: string
};

export default class SimpleSelectComponent extends React.Component<
  PropsType,
  StateType
> {
  static defaultProps = {
    allowComponentUpdate: false,
    enabled: true
  };

  state = {
    error: '',
    touched: false,
    inputValue: this.props.value
  };

  componentDidUpdate(prevProps: PropsType) {
    if (
      this.props.value !== prevProps.value &&
      this.props.allowComponentUpdate
    ) {
      this.setState({
        inputValue: this.props.value,
        error: '',
        touched: false
      });
    }
  }

  handleChange = (element: any): void => {
    this.validationSchema(element.value);
    this.updateState(element.value);
  };

  handleBlur = (): void => {
    this.isValidOptionDefault();
    if (!this.state.touched) {
      this.setState({
        touched: true
      });
    }
  };

  isValidOptionDefault = (): void => {
    const inputValue =
      this.state.inputValue !== null && this.state.inputValue !== undefined
        ? this.state.inputValue
        : '';
    if (inputValue && inputValue.length > 0) {
      const selectedOption = this.props.options.filter(
        option => option.value === inputValue
      );
      if (selectedOption.length > 0) {
        this.validationSchema(inputValue);
      }
    } else {
      this.validationSchema(inputValue);
    }
  };

  updateState = (value: string): void => {
    this.setState({ inputValue: value });
  };

  validationSchema = (inputValue: string): void => {
    const { name } = this.props;
    if (this.props.schema) {
      this.props.schema
        .validate({ inputValue })
        .then(() => {
          this.setStateError('');
        })
        .catch(e => {
          this.setStateError(e.message);
        });
    }

    this.props.onValueChange(inputValue, name);
  };

  setStateError = (error: string): void => {
    this.setState({ error });
  };

  render() {
    const { error, touched } = this.state;
    const { placeholder, minSize, options, isSearchable, enabled } = this.props;
    const selectedOption = options.filter(
      option => option.value == this.props.value
    );
    const disabled = options.length > 0 && enabled;
    const hasError = error && touched;
    const customStyles = this.props.customStyles || getCustomStyle(hasError);

    return (
      <StyledValidatedInput>
        <StyledSelect
          className={this.props.schema ? 'validated' : ''}
          size={minSize}
          isDisabled={!disabled}
          onChange={this.handleChange}
          value={selectedOption}
          onBlur={this.handleBlur}
          placeholder={placeholder}
          isSearchable={isSearchable}
          options={options}
          styles={customStyles}
          maxMenuHeight={'150'}
          blurInputOnSelect={false}
        />
        {this.props.children}
        {hasError && <ErrorMessage>{error}</ErrorMessage>}
      </StyledValidatedInput>
    );
  }
}
